import React, { useState } from "react";
import {
  Button,
  ListItemIcon,
  Menu,
  MenuItem,
  Typography,
} from "@mui/material";
import {
  FeedOutlined as FeedOutlinedIcon,
  History as HistoryIcon,
  KeyboardArrowDown as KeyboardArrowDownIcon,
} from "@mui/icons-material";
import { toggleModal } from "app/store/transmission/slice/transmissionSlice";
import { useDispatch } from "react-redux";
import PreviousReport from "../previous_report/PreviousReport";

const OtherReports = ({
  reportDetail,
  openRegularReportOnNewTab,
  HF_BILLING_CODES,
}) => {
  const dispatch = useDispatch();
  const [anchorEl, setAnchorEl] = useState(null);

  const handleMenuClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handlePreviousReportClick = () => {
    dispatch(toggleModal({ type: "previousReport", value: true }));
    handleMenuClose();
  };

  const handleViewRegularReportClick = () => {
    openRegularReportOnNewTab();
    handleMenuClose();
  };

  return (
    <div>
      <Button
        aria-controls="report-actions-menu"
        aria-haspopup="true"
        onClick={handleMenuClick}
        variant="outlined"
        color="secondary"
        size="small"
        data-action="other-report-dropdown"
        endIcon={<KeyboardArrowDownIcon />}
      >
        Other Reports
      </Button>
      <Menu
        id="report-actions-menu"
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleMenuClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        <MenuItem
          onClick={handlePreviousReportClick}
          data-action="previous-report-menu"
        >
          <ListItemIcon>
            <HistoryIcon fontSize="small" />
          </ListItemIcon>
          <Typography variant="inherit">Previous Report</Typography>
        </MenuItem>
        {!!reportDetail?.hf_file_path &&
          HF_BILLING_CODES.includes(reportDetail?.billing_code) && (
            <MenuItem
              onClick={handleViewRegularReportClick}
              data-action="regular-report-menu"
            >
              <ListItemIcon>
                <FeedOutlinedIcon fontSize="small" />
              </ListItemIcon>
              <Typography variant="inherit">View Regular Report</Typography>
            </MenuItem>
          )}
      </Menu>

      <PreviousReport />
    </div>
  );
};

export default OtherReports;
